import { Box, MenuItem } from '@mui/material';

import { useTranslate } from 'src/locales';
import { ChannelStepLayout } from 'src/pages/channel/shared';
import { AuthLoader } from 'src/pages/auth/components/shared/AuthLoader';
import { MultiSelectAutocomplete } from 'src/pages/tickets/components/custom-multiSelect';

import { Form, Field } from 'src/components/hook-form';

import { useVoiceStep2 } from '../hooks';
import { DID_TYPE_OPTIONS } from '../hooks/useVoiceStep2';

export default function VoiceStep2() {
  const { t } = useTranslate('translation');

  const { methods, assigneeList, isLoading, isNextDisabled, setValue, onSubmit, handleChange } =
    useVoiceStep2();

  const {
    _recordList,
    searchValue,
    isFetching,
    open: openList,
    listScrollHandler,
    searchValueHandler,
    openListHandler,
    closeListHandler,
  } = assigneeList;

  return (
    <>
      {isLoading && <AuthLoader />}

      <Form methods={methods} onSubmit={onSubmit}>
        <ChannelStepLayout title="" isNextDisabled={isNextDisabled}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 3,
            }}
          >
            <Field.Text
              name="didType"
              label={t('DID_TYPE')}
              InputLabelProps={{ shrink: true }}
              select
              onChange={(event: any) => {
                const value = event?.target?.value || '';
                setValue('didType', value, { shouldValidate: true });
                handleChange({ value, fieldName: 'didType' });
              }}
            >
              {DID_TYPE_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Field.Text>

            <MultiSelectAutocomplete
              name="assignUsers"
              label={t('ASSIGNED_TO')}
              placeholder={`+ ${t('ADD_RECIPIENTS')}`}
              isOptionEqualToValue={(a, b) => a.id === b.id}
              options={_recordList}
              searchValue={searchValue}
              listScrollHandler={listScrollHandler}
              searchValueHandler={searchValueHandler}
              open={openList}
              openListHandler={openListHandler}
              closeListHandler={closeListHandler}
              isFetching={isFetching}
            />
          </Box>
        </ChannelStepLayout>
      </Form>
    </>
  );
}
